import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function ReloadController() {
  const { t } = useTranslation('demoAdImages');

  const isImagesGenerating = useSelector((state) => state.demoRecreate.isGenerating);

  useEffect(() => {
    if (!isImagesGenerating) {
      return;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = window.confirm(t('ifYouLeaveThisPageDuringGenerationYourAttemptWillBeLost'));
      return event.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isImagesGenerating, t]);

  return null;
}

export default ReloadController;
